import type { TDraft } from '@/types/drafts'

export function isWordgenieDraftUnfinished(draft: Partial<TDraft> | null): boolean {
  if (!draft) return false

  try {
    const emptyParagraphsRegex = /<p\s[^>]*data-wordgenie-title="[^"]+"[^>]*><\/p>/gi
    const isWordgenieDraft = draft.import_type?.includes('from-wordgenie') ?? false
    const importData = JSON.parse(draft.import_source ?? '{}')
    const hasRequiredData = ['title', 'audience', 'niches', 'language', 'tone'].every(
      (key) => importData[key].length > 0,
    )
    const hasUnfinishedChapters = draft.content?.match(emptyParagraphsRegex) !== null

    return isWordgenieDraft && hasRequiredData && hasUnfinishedChapters
  } catch {
    return false
  }
}